import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { TOKEN_KEY } from '../types/constants';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../services/utils/snackbar.service';
import { ShopSelectionStore } from '../state/shop-selection.store';
import { AuthenticationService } from '../services/authentication';
interface CustomHttpErrorResponse extends HttpErrorResponse {
  isHandled?: boolean;
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbarService = inject(SnackbarService);
  const translateService = inject(TranslateService);
  const shopSelectionStore = inject(ShopSelectionStore);
  const authService = inject(AuthenticationService);

  return next(req).pipe(
    catchError((error: CustomHttpErrorResponse) => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (error.status === 401 && !error.isHandled && token) {
        error.isHandled = true;
        snackbarService.error(
          translateService.instant('auth.error.unauthorized')
        );
        shopSelectionStore.clear();
        authService.logout();
      }

      return throwError(() => error);
    })
  );
};
